<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5.62 9.59"
    aria-hidden="true"
  >
    <path d="M2.46 4.81l3.17 4.78H3.11L0 4.81 3.11 0h2.52z" />
  </svg>
</template>
